import { React, useState } from "react";
import styles from "./DropDownCard.module.scss";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Backdrop from "@mui/material/Backdrop";
import { useDispatch, useSelector } from "react-redux";
import {
  deletePermanently,
  restoreDeletedFile,
  downloadFile,
  shareFile,
} from "../service/actionServices";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function DropDownCard(props) {
  const { _id, filename, ipfsHash } = props.file;
  const dispatch = useDispatch();

  const [shareEmail, setShareEmail] = useState("");
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const handleShareModalOpen = () => setShareModalOpen(true);
  const handleShareModalClose = () => setShareModalOpen(false);

  const userData = useSelector((state) => state.user);
  let userId = userData && userData.userId && userData.userId;

  const imp = !props.file.isImp ? "Important" : "Not Important";
  let dropDown = ["Delete", "Download", imp, "Share", "Details"];

  if (props.page === "bin") {
    dropDown = ["Restore", "Delete permanently"];
  }
  if (props.page === "sharedFiles") {
    dropDown = ["Details", "Download"];
  }

  function itemClickHandler(item) {
    // props.handleActionsMenuClose();
    if (item === imp) {
      props.impHandler(props._id);
      props.handleActionsMenuClose();
    } else if (item === "Delete") {
      props.deleteHandler(props._id);
      props.handleActionsMenuClose();
    } else if (item === "Details") {
      props.handleDetailsOpen();
      props.handleActionsMenuClose();
    } else if (item === "Delete permanently") {
      permanentDeleteHandler();
      props.handleActionsMenuClose();
    } else if (item === "Download") {
      dispatch(downloadFile(ipfsHash, userId, filename));
      props.handleActionsMenuClose();
    } else if (item === "Restore") {
      restoreFile();
      props.handleActionsMenuClose();
    } else if (item === "Share") {
      handleShareModalOpen();
    }
  }

  const permanentDeleteHandler = () => {
    dispatch(deletePermanently(_id, userId, props.filesList));
  };

  const restoreFile = () => {
    dispatch(restoreDeletedFile(_id, userId, props.filesList));
  };

  const shareFileHandler = () => {
    dispatch(shareFile(userId, ipfsHash, shareEmail));
    console.log(userId, ipfsHash, shareEmail);
    props.handleActionsMenuClose();
  };

  return (
    <div>
      <div className={styles.dropDown_container}>
        {dropDown.map((item) => {
          return (
            <div
              className={styles.dropDown_item}
              onClick={() => itemClickHandler(item)}
              key={item}
            >
              {item}
            </div>
          );
        })}

        {/* <DetailsModal open={detailsOpen} handleClose={handleDetailsClose} file={props.file}/> */}
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={shareModalOpen}
          onClose={handleShareModalClose}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{
            backdrop: {
              timeout: 500,
            },
          }}
        >
          <Fade in={shareModalOpen}>
            <Box sx={style}>
              <div className={styles.formContaier}>
                <TextField
                  id="outlined-multiline-flexible"
                  label="Enter Email"
                  onChange={(e) => {
                    setShareEmail(e.target.value);
                  }}
                  required
                />
                <button
                  type="submit"
                  onClick={shareFileHandler}
                  className={styles.sendBtn}
                >
                  send
                </button>
              </div>
            </Box>
          </Fade>
        </Modal>
      </div>
    </div>
  );
}

export default DropDownCard;
